import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-brands-svg-icons';
import { MssIcon, YokoLogo } from '@mss/mss-component-library';
import { sanitizedUrl } from '../../../asset/util/sanitize';

type AssetTypeProps = {
  title: string;
  subtitle: string;
  icon?: IconDefinition;
  page: string;
  mssIcon?: any;
};

const AssetType = ({
  title,
  subtitle,
  icon,
  page,
  mssIcon,
}: AssetTypeProps) => {
  const { url } = useRouteMatch();
  // TODO: 1.11 and onwards, convert to non-arbitrary size/color values
  return (
    <li>
      <Link
        to={`${sanitizedUrl(url)}/${page}`}
        data-ta={`select_${title.replace(' ', '').replace('-', '').toLowerCase()}`}
        className="no-underline text-inherit flex flex-row py-3 px-2 hover:bg-[rgba(65,126,128,0.15)]"
      >
        <div className="flex items-center justify-center max-w-[42px] max-h-[42px] w-[70px] pl-2">
          {mssIcon && <MssIcon icon={mssIcon} className="w-full h-full" />}
          {icon && <FontAwesomeIcon icon={icon} size="3x" />}
          {!icon && !mssIcon && <YokoLogo />}
        </div>
        <div className="pl-4 ml-2">
          <h1 className="text-[19.2px] m-0 font-semibold">{title}</h1>
          <span className="text-gray-700 text-[14.8px]">{subtitle}</span>
        </div>
      </Link>
    </li>
  );
};

export default AssetType;
